import { Group, TextInput, Button, Badge } from '@mantine/core'
import { IconSearch, IconFilter, IconChevronDown, IconChevronUp, IconBuilding } from '@tabler/icons-react'

export interface TenantsToolbarProps {
  searchQuery: string
  onSearchChange: (value: string) => void
  filtersOpen: boolean
  onToggleFilters: () => void
  activeFilterCount: number
  totalCount: number
  filteredCount: number
}

export function TenantsToolbar({
  searchQuery,
  onSearchChange,
  filtersOpen,
  onToggleFilters,
  activeFilterCount,
  totalCount,
  filteredCount,
}: TenantsToolbarProps) {
  const ChevronIcon = filtersOpen ? IconChevronUp : IconChevronDown
  const isFiltered = filteredCount !== totalCount

  return (
    <Group justify="space-between">
      <Group gap="sm">
        <TextInput
          placeholder="Buscar por nome, OU ID ou ambiente..."
          leftSection={<IconSearch size={16} />}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.currentTarget.value)}
          style={{ width: 340 }}
          size="sm"
        />
        <Button
          variant="outline"
          size="sm"
          leftSection={<IconFilter size={14} />}
          rightSection={<ChevronIcon size={14} />}
          onClick={onToggleFilters}
        >
          {activeFilterCount > 0 ? `Filtros (${activeFilterCount})` : 'Filtros'}
        </Button>
      </Group>
      <Badge
        size="lg"
        variant="light"
        leftSection={<IconBuilding size={14} />}
      >
        {isFiltered ? `${filteredCount} / ${totalCount}` : totalCount} tenants
      </Badge>
    </Group>
  )
}
